import React from "react";
import { useTranslation } from "react-i18next";

import Currency from "components/currency";
import Cell from "components/layout/cell";

import styles from "./total_price.module.css";

export default function TotalPrice({
  totalPrice,
  currency,
  discount,
  finalTotalPrice,
  discountedAmount,
  promotions,
  isMember,
}) {
  const { t } = useTranslation();

  return (
    <Cell noLine>
      <div className={styles.main}>
        <div className={styles.discount}>
          <span>{t("hotel_page:total")}</span>
          <Currency amount={totalPrice} currency={currency} />
        </div>
      </div>
      {promotions?.map((promo, index) => (
        <div key={index}>
          <span>{promo?.ratePlan?.title}</span>
          {promo?.discountSequences?.map((ds, i) => (
            <div key={i} className={styles.promo}>
              <span>
                {ds?.promotion?.name} ({ds?.promotion?.discount}% )
              </span>
              <Currency
                amount={-ds?.discountAmount * promo?.ratePlan?.amount}
                currency={currency}
              />
            </div>
          ))}
        </div>
      ))}
      {(discount === 0 || discount > 0) && (
        <div className={styles.discount}>
          <span>{isMember ? t("hotel_page:member_discount") : t("hotel_page:agent_discount")}</span>
          <span>{discount}%</span>
        </div>
      )}

      {discountedAmount ? (
        <div className={styles.sub}>
          {discount > 0 && (
            <s className={styles.price}>
              <Currency amount={totalPrice} currency={currency} />
            </s>
          )}
        </div>
      ) : (
        <></>
      )}

      <h5 className={styles.total}>
        {t("hotel_page:total")} <Currency amount={finalTotalPrice} currency={currency} />
      </h5>
    </Cell>
  );
}
